import React from 'react';
import PreservationFrontDeskList from './components/PreservationFrontDeskList';

const BAFrontDesk = () => <PreservationFrontDeskList />;

export default BAFrontDesk;
